import React from 'react';
import { Stack, Typography, Avatar, useTheme, TableHead, TableRow, TableCell, Table, TableBody } from '@mui/material';
import { ProductListing } from '@domain/product/models/ProductListing';
import { BorderedBlock } from '@shared/ui/common/BorderedBlock';
import { Label } from '@shared/ui/common';


interface ProductListingsProps {
  listings: ProductListing[];
}

const ProductListings: React.FC<ProductListingsProps> = ({
  listings,
}) => {
  const theme = useTheme();

  const openListing = (listing: ProductListing) => {
    window.open(listing.url, '_blank');
  };

  return (

    <BorderedBlock sx={{ p: 0 }} header={<Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Typography variant="subtitle2" color="text.primary">Listings </Typography>
      <Typography variant="body2" color="text.secondary">({listings.length})</Typography>
    </Stack>
    }>


      <Table  sx={{ minWidth: 650 }} size="small">
        <TableHead sx={{ backgroundColor: theme.palette.background.default }}>
          <TableRow>

            <TableCell>Listing</TableCell>

            <TableCell>Connection</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(!listings || listings.length === 0) ? (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  No listings. Add listings for this product.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            listings.map((listing) => (
              <TableRow
                hover
                key={listing.id}
                sx={{ cursor: 'pointer' }}
                onClick={() => openListing(listing)}
              >

                <TableCell>
                  <Typography variant="body2">
                    {listing.title || listing.marketplace.name}
                  </Typography>
                </TableCell>


                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      variant="rounded"
                      src={listing.connection.connector.image}
                      sx={{
                        width: 40,
                        height: 40,
                        border: 1,
                        borderColor: theme.palette.divider,
                      }}
                      slotProps={{
                        img: {
                          style: { objectFit: 'contain' }
                        }
                      }}
                    />
                    <Typography variant="body2">{listing.connection.name}</Typography>
                  </Stack>
                </TableCell>
                <TableCell align="right">
                  <Label
                    options={[
                      { value: 'active', label: 'Active', color: theme.palette.success.light },
                      { value: 'inactive', label: 'Inactive', color: theme.palette.error.light }
                    ]}
                    currentValue={listing.active ? 'active' : 'inactive'}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

    </BorderedBlock>

  );
};

export default ProductListings;
